import React from 'react';
import clsx from 'clsx';

import {SvgIconReact} from 'common/components/svg-icon';
import {withStyles} from 'common/util/react';

import {Lottie} from '../lottie';
import {SpinnerColor, SpinnerSize, SpinnerTheme} from './types';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
import limitedSegLottie from './limited-seg.lottie';

interface SpinnerProps {
  color?: SpinnerColor;
  size?: SpinnerSize;
  theme?: SpinnerTheme;
  className?: string;
  style?: React.CSSProperties;
  role?: string;
  elref?: string;
}

const Spinner = ({
  color = SpinnerColor.Blue,
  size = SpinnerSize.Small,
  theme = SpinnerTheme.Default,
  className,
  style,
  elref,
}: SpinnerProps) => {
  const showCustomSpinner = theme !== SpinnerTheme.Default;
  const isFancy = theme === SpinnerTheme.Fancy;

  return (
    <div
      elref={elref}
      style={style}
      className={clsx(styles.spinnerWrapper, className, {
        [styles.xs]: size === SpinnerSize.XS,
        [styles.large]: size === SpinnerSize.Large && !isFancy,
        [styles.mediumFancy]: size === SpinnerSize.Medium && isFancy,
        [styles.largeFancy]: size === SpinnerSize.Large && isFancy,
      })}
    >
      <div
        className={clsx({
          [styles.mpSpinner]: !showCustomSpinner,
          [styles.mpSpinnerBlue]: !showCustomSpinner && color === SpinnerColor.Blue,
          [styles.mpSpinnerWhite]: !showCustomSpinner && color === SpinnerColor.White,
          [styles.mpSpinnerInheritColor]: !showCustomSpinner && color === SpinnerColor.Inherit,
          [styles.customSpinner]: showCustomSpinner,
          [styles.fancy]: isFancy,
          [styles.largeSpinner]: size === SpinnerSize.Large,
          [styles.mediumSpinner]: size === SpinnerSize.Medium,
        })}
      >
        {!showCustomSpinner && <SvgIconReact icon='spinner' />}
        {isFancy && <Lottie config={{path: limitedSegLottie}} />}
      </div>
    </div>
  );
};

export const SpinnerReact = withStyles(Spinner, css);
